module.exports = __webpack_public_path__ + "static/img/3.de9d078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/3.png
// module id = xP5y
// module chunks = 0